export default "__VITE_ASSET__La24mv3n__"